module.exports = __webpack_public_path__ + "static/time-calendar-70f36ebe7b5b3bb6aa2949ce267d6705.svg";